import Route from "@ember/routing/route";

export default class TermsOfUseRoute extends Route {}
